import { createApi } from '@reduxjs/toolkit/query/react'
import { getBaseQuery, getBaseUrl } from '@/apis/api.util.ts'
import {
  PaginatedPositionListResponse,
  PositionListRequest,
} from '@/apis/position/position-api.def.ts'

export const positionApi = createApi({
  reducerPath: 'positionApi',
  baseQuery: getBaseQuery(getBaseUrl('idea')),
  endpoints: (build) => ({
    getPositionsPaginated: build.query<
      PaginatedPositionListResponse,
      PositionListRequest
    >({
      query: (params) => ({
        url: '/positions',
        method: 'GET',
        params: {
          page: params.page,
          pageSize: params.pageSize,
          includeLiquidated: params.includeLiquidated,
          ...(params.userId && { userId: params.userId }),
          ...(params.orderBy && { orderBy: params.orderBy }),
          ...(params.orderDirection && {
            orderDirection: params.orderDirection,
          }),
          ...(params.filterColumn && { filterColumn: params.filterColumn }),
          ...(params.filterText && { filterText: params.filterText }),
          ...(params.startDate && { startDate: params.startDate }),
          ...(params.endDate && { endDate: params.endDate }),
        },
      }),
    }),
  }),
})

export const { useLazyGetPositionsPaginatedQuery } = positionApi
